<template>
    <div class="input-holder relative w-full mb-4" :class="[hover && !focused && !hasErrors ? 'text-neutral-default' : '', hover && focused && !hasErrors || focused && !hasErrors ? 'text-primary-darker' : '', !hover && !hasErrors ? 'text-gray-700' : '', hasErrors ? 'text-red-500' : '']" @mouseover="hover = true" @mouseleave="hover = false">
        <label v-if="label" :for="(idPrefix ?idPrefix +'_':'')+'input_' +name" :class="[labelClass ? labelClass : '', focused || modelValue ? '-top-4':'top-2',hover && !focused && !hasErrors ? labelColorHover : '', hover && focused && !hasErrors || focused && !hasErrors ? 'text-primary-darker' : '', !hover && !hasErrors ? ( focused || modelValue ? labelColor : labelColor) : '', hasErrors ? 'text-red-500' : '']" class="text-sm font-plus-sans-bold transition-all ease-in-out duration-500">{{ $t(label) + (required ? ' *' : '') }}<span v-html="labelNotice ? ' ' + labelNotice : ''"></span></label>

            <textarea
                :id="(idPrefix ?idPrefix +'_':'')+'input_' +name"
                :value="modelValue"
                rows="4"
                class="border transition-colors resize-none ease-in-out duration-500 w-full px-3 py-1 outline-none"
                :class="[{empty: modelValue === '', 'text-secondary-default':orgValueButton && !focused,'opacity-25 cursor-not-allowed':disabled} , icon ? 'pr-8' : '', ...borderClass]"
                :type="inputType"
                :name="name"
                @input="$emit('update:modelValue', $event.target.value)"
                @blur="$emit('blur');onBlur();"
                @keyup.enter="$emit('keyup.enter', $event.target.value)"
                @keyup="$emit('keyup', $event)"
                @focus="$emit('focus', $event),onFocus();"
                @click="$emit('click', $event)"
                :placeholder="placeholder"
                :autofocus="autofocus"
                :ref="(idPrefix ?idPrefix +'_':'')+name"
                :readonly="readonly || isDate"
                :disabled="disabled"
                :required="required"
                :style="inputStyle"
                @keypress="validateValue"
            >{{ modelValue }}</textarea>
        <ValidationMessages v-if="validations" :validations="validations" :hide-errors="hideErrors" :has-errors="hasErrors" :error-position="errorPosition"/>
    </div>
</template>
<script>

export default {
    data() {
        return {
            focused: false,
            hover: false,
            inputType: 'text',
            date: new Date(),
        }
    },
    props: {
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        modelValue: {
            type: [String, Number],
            default: ''
        },
        orgValue: {
            type: [String, Number],
            default: ''
        },
        name: {
            type: String,
            required: false,
            default: ''
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        icon: {
            type: String,
            required: false,
            default: ''
        },
        labelNotice: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        autocomplete: {
            type: String,
            required: false,
            default: ''
        },
        idPrefix: {
            type: String,
            required: false,
            default: ''
        },
        focus: {
            type: Boolean,
            required: false,
            default: false
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false
        },
        validations: {
            type: Array,
            default: () => []
        },
        inputClass: {
            type: String,
            required: false,
            default: ''
        },
        borderColor: {
            type: String,
            required: false,
            default: 'border-gray-200'
        },
        borderColorHover: {
            type: String,
            required: false,
            default: 'border-neutral-default'
        },
        textColor: {
            type: String,
            required: false,
            default: 'text-neutral-default'
        },
        labelColor:{
            type: String,
            required: false,
            default: 'text-gray-600'
        },
        labelColorHover:{
            type: String,
            required: false,
            default: 'text-primary-default'
        },
        inputStyle: {
            type: String,
            required: false,
            default: ''
        },
        labelClass: {
            type: String,
            required: false,
            default: ''
        },
        hideErrors: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        active: {
            type: Boolean,
            required: false,
            default: false
        },
        errorPosition: {
            type: String,
            required: false
        },
        required:{
            type: Boolean,
            required: false,
            default: false
        },
        onlyNumber:{
            type: Boolean,
            required: false,
            default: false
        },
        isDate: {
            type: Boolean,
            required: false,
            default: false
        },
        numberFormat: {
            type: Object,
            required: false,
            default: {
                precision : 0,
                thousand : ".",
                decimal : ","
            }
        },
        unformat: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    watch: {
        focused: {
            async handler (newValue, oldValue) {

                if(this.onlyNumber){
                    if(newValue)
                    {
                        this.$emit('update:modelValue', (this.unformatNumber(this.modelValue)).toString())
                    } else {
                       this.$emit('update:modelValue', (this.formatNumber(this.modelValue)).toString())
                    }
                }
            }
        }
    },
    computed: {
        hasErrors() {

            var hasErrors = false;
            this.validations.forEach(validation => {

                if (validation.condition) {
                    hasErrors = true;
                    return;
                }
            })

            return hasErrors;
        },
        isPassword() {
            return this.type == 'password';
        },
        orgValueButton(){

            if(this.onlyNumber){
                return this.formatNumber(this.orgValue) != this.modelValue && this.orgValue != ''
            } else{
                return this.orgValue != this.modelValue && this.orgValue != ''
            }
        },
        borderClass(){
            return [this.inputClass ? this.inputClass : '' , this.hover && !this.focused && !this.hasErrors ? this.borderColorHover : '', this.hover && this.focused && !this.hasErrors || this.focused && !this.hasErrors ? 'border-primary-darker' : '', !this.hover && !this.hasErrors ? this.borderColor : '', this.hasErrors ? 'border-red-500 text-red-500' : ''];
        },
        iconBorderClass (){
         if(this.isDate) return this.borderClass
        }
    },

    methods: {
        unformatNumber(value) {
            value = this.$accounting.unformat(value, this.numberFormat.decimal)
            if (value === 0) {
                return  0
            } else {
                return this.$accounting.formatMoney(value, {
                    symbol: '',
                    format: '%v',
                    thousand: '',
                    decimal: this.numberFormat.decimal,
                    precision: Number(this.numberFormat.precision)
                })
            }
        },
        formatNumber(value) {
            value = this.$accounting.unformat(value, this.numberFormat.decimal);

            if(value < 0) value = 0

            return this.$accounting.formatMoney(value, {
                symbol: '',
                format: '%v',
                precision: Number(this.numberFormat.precision),
                decimal: this.numberFormat.decimal,
                thousand: this.numberFormat.thousand
            })


            return this.$accounting.formatNumber(value , this.numberFormat.precision, this.numberFormat.thousand, this.numberFormat.decimal);
        },
        onFocus() {
            this.focused = true;
        },
        onBlur() {
            this.focused = false;
        },
        setFocus(fieldName) {
            if (this.name === fieldName) {
                this.$refs[(this.idPrefix ? this.idPrefix +'_':'')+ this.name].focus()
            }
        },
        clickIcon(){

            if(this.isPassword){
                this. togglePassword();
            } else if(this.isDate){
                this. toggleDate();
            } else if( this.orgValueButton){

                if(this.onlyNumber){
                    this.$emit('update:modelValue', (this.formatNumber(this.orgValue)).toString())
                } else{
                    this.$emit('update:modelValue', this.orgValue.toString())
                }

                //console.log('orgValueButton',this.orgValue)
            }

        },
        togglePassword() {
            this.inputType = this.inputType == 'password' ? 'text' : 'password'
        },
        toggleDate() {
            console.log('Date')
        },
        initializeDatePicker() {

            let picker = new this.$litepicker({
                element: this.$refs[(this.idPrefix ? this.idPrefix +'_':'')+this.name + '_trigger'],
                singleMode: true,
                lang: 'de-DE',
                format: 'DD.MM.YYYY',
                setup: (picker) => {
                    picker.on('selected', (date1, date2) => {
                        this.$emit('update:modelValue',this.$moment(String(date1.dateInstance)).format('DD.MM.YYYY'))
                    });
                },
            });
        },
        validateValue(event){

            const charCode = String.fromCharCode(event.keyCode);
           // console.log(charCode)
            if (!/[0-9]/.test(charCode)) {
             //   event.preventDefault();
            }

        }
    },
    mounted() {

        if(this.onlyNumber){

            this.$emit('update:modelValue', (this.formatNumber(this.modelValue)).toString())

        }

        this.inputType = this.type;
        if (this.focus) {
            this.$refs[this.name].focus()
        }

        if(this.isDate) this.initializeDatePicker();


    }
}
</script>
